import React from "react";
import Character1Kitchen from "./Character1Kitchen.js"
import Character2Kitchen from "./Character2Kitchen.js"
import Character3Kitchen from "./Character3Kitchen.js"
import Character4Kitchen from "./Character4Kitchen.js"

class CharacterKitchen extends React.Component {
  state = { svg: null };

  componentDidMount() {
    const svgSupport =
      !!document.createElementNS &&
      !!document.createElementNS("http://www.w3.org/2000/svg", "svg")
        .createSVGRect;
    if (svgSupport) {
      this.setState({
        svg: "svg"
      });
    } else {
      this.setState({
        svg: "png"
      });
    }
  }
  render() {
    return (
      <div
        className={
          "option character-illustration-wrapper character-kitchen " +
          this.state.svg
        }
      >
        {this.props.characterReference === "character-1" && <Character1Kitchen/>}
        {this.props.characterReference === "character-2" && <Character2Kitchen/>}
        {this.props.characterReference === "character-3" && <Character3Kitchen/>}
        {this.props.characterReference === "character-4" && <Character4Kitchen/>}
        <svg className={"character-background character-kitchen-background"} />
      </div>
    );
  }
}

export default CharacterKitchen;
